module.exports = __webpack_public_path__ + "static/animation-856b938d09f352d923823febe68c54f2.gif";